import { createContext } from '@lit/context';
import { FilterMenu } from '../filter/filter-menu.js';

export const filterContext = createContext<FilterMenu>('filterMenu');
